module.exports = __webpack_public_path__ + "img/qr_2.da1cbbe4.png";